import initialState from "./initialState";
import * as types from "../actions/actionTypes";
import { AppState } from "../types/reduxState";

interface appActions {
  type: string;
  payload: any;
}

export default function appReducer(currentState: AppState, action: appActions): any {
  const state = currentState || initialState.app;
  switch (action.type) {
    case types.SET_SUCCESS_MESSAGE:
      return {
        ...state,
        successMessage: action.payload,
      };

    case types.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
      };

    case types.SET_APPLY_BLOCKED:
      return {
        ...state,
        applyBlocked: action.payload,
      };

    case types.CLEAR_APPLY_BLOCKED:
      return {
        ...state,
        applyBlocked: null,
      };

    case types.SET_LOADING_STATE:
      return {
        ...state,
        loader: action.payload,
      };

    case types.SET_USER_INFO:
      return {
        ...state,
        user: action.payload,
        // userRole: action?.payload?.roles?.[0]??action?.payload?.user?.roles[0]??""
      };

    case types.SET_HOBBIES:
      return {
        ...state,
        hobbies: action.payload,
      };

    case types.SET_LANGUAGES:
      return {
        ...state,
        languages: action.payload,
      };

    case types.SET_DEPARTMENTS:
      return {
        ...state,
        departments: action.payload,
      };

    case types.SET_DESIGNATIONS:
      return {
        ...state,
        designations: action.payload,
      };

    case types.SET_INDUSTRIES:
      return {
        ...state,
        industries: action.payload,
      };

    case types.SET_BOARDS:
      return {
        ...state,
        boards: action.payload,
      };

    case types.SET_DEGREES:
      return {
        ...state,
        degrees: action.payload,
      };

    case types.SET_COURSE_NAMES:
      return {
        ...state,
        courseNames: action.payload,
      };

    case types.SET_COURSE_SPECIALIZATION:
      return {
        ...state,
        courseSpecializations: action.payload,
      };

    case types.SET_TOOLS_KNOWN:
      return {
        ...state,
        toolsKnown: action.payload,
      };

    case types.SET_SKILLS:
      return {
        ...state,
        skills: action.payload,
      };

    case types.SET_FUNCTIONS:
      return {
        ...state,
        functions: action.payload,
      };

    case types.SET_JOB_ROLES:
      return {
        ...state,
        jobRoles: action.payload,
      };

    case types.SET_UNIVERSITY:
      return {
        ...state,
        university: action.payload,
      };

    case types.SET_CITIES:
      return {
        ...state,
        cities: action.payload,
      };

    case types.SET_HIRING_COMPANIES:
      return {
        ...state,
        hiringCompanies: action.payload,
      };

    case types.SET_USER_DETAILS:
      return {
        ...state,
        userProfile: action.payload,
      };

    case types.SET_USER_PREFERENCE:
      return {
        ...state,
        userPreference: action.payload,
      };

    case types.SET_USER_EXPERIENCE:
      return {
        ...state,
        userExeperience: action.payload,
      };

    case types.SET_USER_EDUCATION:
      return {
        ...state,
        userEducation: action.payload,
      };

    case types.SET_USER_CERTIFICATE:
      return {
        ...state,
        userCertificates: action.payload,
      };

    case types.SET_QUESTIONS:
      return {
        ...state,
        questions: action.payload,
      };

    case types.SET_PERSONALITY:
      return {
        ...state,
        personality: action.payload,
      };

    case types.SET_TOPIC_SCORE:
      return {
        ...state,
        topicScore: action.payload,
      };

    case types.SET_SCORE_BAND:
      return {
        ...state,
        scoreBand: action.payload,
      };

    case types.SET_PERKS:
      return {
        ...state,
        perks: action.payload,
      };

    case types.UPDATE_PROMPT:
      return {
        ...state,
        prompts: {
          ...state.prompts,
          ...action.payload,
        },
      };

    case types.SET_PROMPTS:
      return {
        ...state,
        prompts: {
          ...action.payload,
        },
      };

    case types.SET_USER_VIDEOS:
      return {
        ...state,
        userVideos: action.payload,
      };

    case types.SET_VIDEO_QUESTIONS:
      return {
        ...state,
        videoQuestions: action.payload,
      };

    default:
      return state;
  }
}
